export default "/img/AS.b84f6c224c8f15bc0bef6d810c9c913b.png";